"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenToHash = void 0;
var JsCrypto = require("jscrypto");
var tokenToHash = function (_a) {
    var secretToken = _a.secretToken;
    return JsCrypto.SHA256.hash(secretToken).toString(JsCrypto.Base64);
};
exports.tokenToHash = tokenToHash;
